attachEvent('.footer__column-title', 'click', (ev) => {
  if (windowWidth() < breakpointSm) {
    const parent = ev.target.closest('.footer__column');
    const links = parent.querySelector('.footer__column-links');

    ev.target.classList.toggle('is-open');
    slideToggle(links, 300, 'flex');
  }
});
